// Talks to the Worker's non-BYOK surface: server config (is the app gated? is a
// server voice available?) and the access-password gate that protects our
// Workers-AI resource. The password lives in localStorage and rides as a header
// on server-voice/transcription calls; it's validated server-side.

export interface ServerConfig {
  gated: boolean;
  serverVoice: boolean;
  version?: string;
}

const AUTH_LS = 'ielts.auth.v1';
let cfg: ServerConfig = { gated: false, serverVoice: false };
let loaded = false;

export async function loadServerConfig(): Promise<ServerConfig> {
  try {
    const res = await fetch('/api/config', { cache: 'no-store' });
    if (res.ok) cfg = (await res.json()) as ServerConfig;
  } catch {
    cfg = { gated: false, serverVoice: false };
  }
  loaded = true;
  return cfg;
}

export function serverConfig(): ServerConfig {
  return cfg;
}
export function configLoaded(): boolean {
  return loaded;
}

export function getAppPassword(): string {
  return localStorage.getItem(AUTH_LS) || '';
}
export function setAppPassword(pw: string): void {
  localStorage.setItem(AUTH_LS, pw);
}
export function clearAppPassword(): void {
  localStorage.removeItem(AUTH_LS);
}

/** Header to authorize server-voice/transcription calls (empty if no password). */
export function appPasswordHeader(): Record<string, string> {
  const p = getAppPassword();
  return p ? { 'x-app-password': p } : {};
}

/** Is the server voice/transcription usable right now? */
export function serverReady(): boolean {
  return cfg.serverVoice && (!cfg.gated || !!getAppPassword());
}

/** Does the app need to show the password gate before use? */
export function needsGate(): boolean {
  return cfg.gated && !getAppPassword();
}

/** Verify a password against the Worker; on success, store it. */
export async function verifyPassword(pw: string): Promise<boolean> {
  try {
    const res = await fetch('/api/auth', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ password: pw }),
    });
    if (res.ok) {
      setAppPassword(pw);
      return true;
    }
    return false;
  } catch {
    return false;
  }
}
